"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AIRTIME_TOPUP = exports.paymentTypes = exports.LAYBUY = exports.LOAN = exports.CARD = void 0;
exports.CARD = "card";
exports.LOAN = "loan";
exports.LAYBUY = "laybuy";
exports.paymentTypes = [exports.LOAN, exports.LAYBUY]; // Hiding Card Payment option for now.
exports.AIRTIME_TOPUP = "airtime top-up";
